<template>
    <div>
        <section-one></section-one>
        <recomand-pc></recomand-pc>
        <recomand></recomand>
        <benefit></benefit>
        <effect></effect>
    </div>
</template>
<script>
import sectionOne from '@/components/officailPage/bussiness/sectionOne.vue';
import recomandPc from '@/components/officailPage/bussiness/recomandPc.vue';
import recomand from '@/components/officailPage/bussiness/recomand.vue';
import benefit from '@/components/officailPage/bussiness/benefit.vue';
import effect from '@/components/officailPage/bussiness/effect.vue';

export default {
    components: {
        sectionOne,
        recomandPc,
        recomand,
        benefit,
        effect
    }
}
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/officailPage/bussiness/bussiness.vue